import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { FormField } from '../../../model/category-management-dto';

/**
 * Vista previa interactiva del formulario dinámico, aproximando cómo lo
 * renderiza el app móvil. Al responder un campo con dependencias se muestran
 * los campos anidados (recursivo).
 */
@Component({
  selector: 'app-form-preview',
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule],
  templateUrl: './form-preview.component.html',
  styleUrl: './form-preview.component.scss'
})
export class FormPreviewComponent {

  @Input() fields: FormField[] = [];

  /** Valores seleccionados por nombre de campo (solo para la vista previa) */
  values: { [name: string]: any } = {};

  /** Espacios de foto que se dibujan como referencia visual en la vista previa */
  photoSlots = [1, 2, 3];

  setValue(field: FormField, value: any): void {
    this.values[field.name] = value;
  }

  getValue(field: FormField): any {
    return this.values[field.name];
  }

  toggleMultiselect(field: FormField, option: string): void {
    const current: string[] = this.values[field.name] || [];
    this.values[field.name] = current.includes(option)
      ? current.filter(o => o !== option)
      : [...current, option];
  }

  isSelected(field: FormField, option: string): boolean {
    const value = this.values[field.name];
    return Array.isArray(value) ? value.includes(option) : value === option;
  }

  counterValue(field: FormField): number {
    return this.values[field.name] ?? (field.counterConfig?.min ?? 0);
  }

  incrementCounter(field: FormField, delta: number): void {
    const min = field.counterConfig?.min ?? 0;
    const max = field.counterConfig?.max ?? 99;
    const next = Math.min(max, Math.max(min, this.counterValue(field) + delta));
    this.values[field.name] = next;
  }

  activeDependencies(field: FormField): FormField[] {
    if (!field.dependencies) {
      return [];
    }
    const value = this.values[field.name];
    if (value == null) {
      return [];
    }
    return field.dependencies[value] || [];
  }

  confirmationOptions(field: FormField): string[] {
    const options = [field.confirmText || 'Sí', field.cancelText || 'No'];
    if (field.neutralText) {
      options.push(field.neutralText);
    }
    return options;
  }
}
